
import consola from 'consola'
import { Resource } from '../models/resource'

const logger = consola.withTag('EditableDirective')

let config;
try {
    config = require('@/model.config').default
} catch (ex) {
    logger.debug('No model overrides, using default resource...')
}

export const BaseResource = config?.BaseModel || Resource
